/** 右下に表示するフローティングポップアップ */
export default function FloatingPopup({
  onClick,
  visible,
  trialDaysRemaining,
}: {
  onClick: () => void;
  visible: boolean;
  trialDaysRemaining: number | null;
}) {
  return (
    <div
      className="fixed right-0 bottom-6 z-[1000] flex h-[109px] flex-col items-center justify-center gap-xs rounded-l-xl bg-white/80 px-xxl py-sm shadow-layer4 transition-all duration-700 ease-out"
      style={{
        boxShadow: '0 0 24px rgba(0, 0, 0, 0.2)',
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(20px)',
        pointerEvents: visible ? 'auto' : 'none',
      }}
    >
      {trialDaysRemaining !== null && trialDaysRemaining <= 5 ? (
        <p className="text-heading-3xs">
          \ トライアル版終了まで<span className="text-danger">あと{trialDaysRemaining}日</span> /
        </p>
      ) : (
        <p className="text-heading-3xs">\ お気軽にご相談ください！/</p>
      )}

      <button
        type="button"
        onClick={onClick}
        className="flex h-8 w-[221px] items-center justify-center rounded-full px-4 text-button-md text-white"
        style={{
          background: 'linear-gradient(90deg, #005fff 0%, #ed72f8 100%)',
          boxShadow: '0 0 12px rgba(0, 0, 0, 0.2)',
        }}
      >
        無料相談はこちら
      </button>
    </div>
  );
}
